export const SEARCH_ROUTES = ["/leit", "/vorur"];
